import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { riderApi } from '../../api/riders';

/** "7 papers", or the one paper by name. */
function owedInWords(owed) {
  return owed.length === 1 ? `one paper: ${owed[0].label}` : `${owed.length} papers`;
}

/**
 * Asks a working rider for the papers they still owe (InGo ADR 0006 §5; Rio,
 * 2 Oct 2026: "Work, papers owed"). A rider carried over approved from the old
 * app works from day one and sends every paper again; `owed` on
 * `GET rider/me/application` lists what is missing, refused or past its date.
 *
 * Never a block: a rider who may not work is already on the application
 * screen (DriverApprovalGate), and a question that could not be asked (no
 * signal, the server down) shows nothing rather than an error on the home.
 */
export default function PapersOwedNotice({ rider = riderApi }) {
  const [owed, setOwed] = useState([]);

  useEffect(() => {
    let cancelled = false;

    rider.application().then(
      (application) => {
        if (cancelled) return;
        setOwed(application?.may_work === true && Array.isArray(application.owed) ? application.owed : []);
      },
      () => {},
    );

    return () => {
      cancelled = true;
    };
  }, [rider]);

  if (owed.length === 0) return null;

  return (
    <p className="dh__alert dh__alert--info" role="status">
      The office still needs {owedInWords(owed)} from you. You can keep working meanwhile.{' '}
      <Link to="/driver/application" style={{ color: 'inherit', fontWeight: 700 }}>
        Send your papers
      </Link>
    </p>
  );
}
